var map = {
	"./admin.js": "yyzr",
	"./login.js": "9ohU",
	"./product_img.js": "3YB6",
	"./product_info.js": "Joqw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "S7Tj";


//////////////////
// WEBPACK FOOTER
// ./src/api/interface nonrecursive \.js$
// module id = S7Tj
// module chunks = 9